export class ApiLabels<T> {
    labels: Array<T>;
    constructor() {
        this.labels = new Array<T>();
    }
}


// WEBPACK FOOTER //
// ./src/app/client-core/api-response-models/api-labels.model.ts